// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { PostAvailableImageryData, PostAvailableImageryResponse, PostCcuData, PostCcuResponse, GetCcuData, GetCcuResponse, GetCcuForecastResponse, GetCompaniesResponse, PostCompaniesData, PostCompaniesResponse, GetCompanyData, GetCompanyResponse, GetCompanyAccessData, GetCompanyAccessResponse, PutCompanyCustomSpeciesData, PutCompanyCustomSpeciesResponse, GetCompanyCustomSpeciesData, GetCompanyCustomSpeciesResponse, DeleteCompanyCustomSpeciesData, DeleteCompanyCustomSpeciesResponse, GetCompanyPropertiesData, GetCompanyPropertiesResponse, PutCompanyPropertiesData, PutCompanyPropertiesResponse, PutCompanyPropertiesParticipantSpecificTableXlsData, PutCompanyPropertiesParticipantSpecificTableXlsResponse, GetCompanyTasksData, GetCompanyTasksResponse, GetCompanyUsersData, GetCompanyUsersResponse, PostCompanyUsersInvitationData, PostCompanyUsersInvitationResponse, GetCompanyUserData, GetCompanyUserResponse, DeleteCompanyUserTagsAllData, DeleteCompanyUserTagsAllResponse, PostCompanyUserData, PostCompanyUserResponse, DeleteCompanyUserData, DeleteCompanyUserResponse, PostCtrData, PostCtrResponse, GetCtrShapefileResponse, GetCtrData, GetCtrResponse, GetCustomersResponse, GetCustomersOverviewResponse, GetCustomerAccessData, GetCustomerAccessResponse, PostCustomerAltcertEvaluateData, PostCustomerAltcertEvaluateResponse, GetCustomerBalanceForwardData, GetCustomerBalanceForwardResponse, GetCustomerBillingAddressData, GetCustomerBillingAddressResponse, GetCustomerBoundaryData, GetCustomerBoundaryResponse, GetCustomerCaasYieldsData, GetCustomerCaasYieldsResponse, PostCustomerCarbonStockPipelineEtsEvaluateData, PostCustomerCarbonStockPipelineEtsEvaluateResponse, PostCustomerCarbonStockPipelineRunFlowData, PostCustomerCarbonStockPipelineRunFlowResponse, GetCustomerCompanyData, GetCustomerCompanyResponse, PostCustomerCompanyData, PostCustomerCompanyResponse, DeleteCustomerCompanyData, DeleteCustomerCompanyResponse, GetCustomerCompanyCustomSpeciesData, GetCustomerCompanyCustomSpeciesResponse, GetCustomerCompanyCustomSpeciesSummaryData, GetCustomerCompanyCustomSpeciesSummaryResponse, GetCustomerCreditNotesData, GetCustomerCreditNotesResponse, PostCustomerEconomicsByFeatureData, PostCustomerEconomicsByFeatureResponse, PostCustomerEconomicsUpdateData, PostCustomerEconomicsUpdateResponse, GetCustomerEtsLandDistrictData, GetCustomerEtsLandDistrictResponse, GetCustomerGdriveData, GetCustomerGdriveResponse, PostCustomerGdriveData, PostCustomerGdriveResponse, PostCustomerInvoicesData, PostCustomerInvoicesResponse, GetCustomerInvoicesData, GetCustomerInvoicesResponse, GetCustomerInvoicePdfData, GetCustomerInvoicePdfResponse, DeleteCustomerInvoiceData, DeleteCustomerInvoiceResponse, GetCustomerInvoiceFileIdData, GetCustomerInvoiceFileIdResponse, GetCustomerInvoicePaymentsData, GetCustomerInvoicePaymentsResponse, PutCustomerInvoicePaymentStatusData, PutCustomerInvoicePaymentStatusResponse, PutCustomerInvoicePropertiesData, PutCustomerInvoicePropertiesResponse, PutCustomerInvoicePropertiesNzusIssuedData, PutCustomerInvoicePropertiesNzusIssuedResponse, PostCustomerInvoiceSendData, PostCustomerInvoiceSendResponse, PutCustomerInvoiceStatusData, PutCustomerInvoiceStatusResponse, GetCustomerKmlFileData, GetCustomerKmlFileResponse, PostCustomerLayersData, PostCustomerLayersResponse, GetCustomerLayersData, GetCustomerLayersResponse, PostCustomerLayerData, PostCustomerLayerResponse, GetCustomerLayerData, GetCustomerLayerResponse, DeleteCustomerLayerData, DeleteCustomerLayerResponse, GetCustomerLayerVersionsData, GetCustomerLayerVersionsResponse, GetCustomerMeasuresData, GetCustomerMeasuresResponse, GetCustomerParcelstatusData, GetCustomerParcelstatusResponse, PostCustomerPerEmailData, PostCustomerPerEmailResponse, GetCustomerPhotosRequestedPointsData, GetCustomerPhotosRequestedPointsResponse, PostCustomerPhotosRequestedPointsData, PostCustomerPhotosRequestedPointsResponse, PostCustomerPhotosTakenData, PostCustomerPhotosTakenResponse, GetCustomerPhotosTakenData, GetCustomerPhotosTakenResponse, DeleteCustomerPhotosTakenData, DeleteCustomerPhotosTakenResponse, PutCustomerPhotosTakenArchivedData, PutCustomerPhotosTakenArchivedResponse, GetCustomerPhotosTakenPointsData, GetCustomerPhotosTakenPointsResponse, GetCustomerPropertiesData, GetCustomerPropertiesResponse, PostCustomerPropertiesData, PostCustomerPropertiesResponse, GetCustomerSegmentationFeaturePropertyData, GetCustomerSegmentationFeaturePropertyResponse, PatchCustomerSegmentationFeaturePropertyData, PatchCustomerSegmentationFeaturePropertyResponse, PostCustomerSegmentsData, PostCustomerSegmentsResponse, GetCustomerSegmentsData, GetCustomerSegmentsResponse, PostCustomerSegmentsEtsRegistrationData, PostCustomerSegmentsEtsRegistrationResponse, GetCustomerSegmentsEtsRegistrationData, GetCustomerSegmentsEtsRegistrationResponse, GetCustomerTasksData, GetCustomerTasksResponse, PutCustomerTasksData, PutCustomerTasksResponse, PostCustomerTasksInvoiceData, PostCustomerTasksInvoiceResponse, DeleteCustomerTaskData, DeleteCustomerTaskResponse, PostCustomerTitlesData, PostCustomerTitlesResponse, GetCustomerTitlesData, GetCustomerTitlesResponse, GetCustomerTokenData, GetCustomerTokenResponse, GetCustomerUsersData, GetCustomerUsersResponse, PostCustomerUsersInvitationData, PostCustomerUsersInvitationResponse, DeleteCustomerUserData, DeleteCustomerUserResponse, PostCustomerUserTagData, PostCustomerUserTagResponse, DeleteCustomerUserTagData, DeleteCustomerUserTagResponse, GetHubspotDealData, GetHubspotDealResponse, PostHubspotDealPropertiesData, PostHubspotDealPropertiesResponse, GetNzuForecastResponse, DeleteSiteUserData, DeleteSiteUserResponse, PostUsersData, PostUsersResponse, GetUsersData, GetUsersResponse, GetUsersMeResponse, GetUsersMeCompaniesResponse, GetUsersMeCustomersResponse, GetUsersMeTokenResponse, GetUserData, GetUserResponse, PutUserData, PutUserResponse, DeleteUserData, DeleteUserResponse, GetUserCompaniesData, GetUserCompaniesResponse, GetUserCustomersData, GetUserCustomersResponse, GetCompanyCustomersV2Data, GetCompanyCustomersV2Response, PostCustomersV2Data, PostCustomersV2Response, GetCustomerEconomicsV2Data, GetCustomerEconomicsV2Response, PostCustomerEconomicsV2Data, PostCustomerEconomicsV2Response, PostCustomerShapefileV2Data, PostCustomerShapefileV2Response, PutCustomerTasksInvoiceV2Data, PutCustomerTasksInvoiceV2Response, GetVersionResponse, GetResponse, GetDocsResponse } from './types.gen';

/**
 * Available Imagery
 * Get all available imagery layers for a given geometry.
 * Optional: specify sources_to_check to limit the search to specific sources.
 * Optional: full_coverage: only return layers that fully cover the given geometry.
 * @param requestBody
 * @param sourcesToCheck
 * @param fullCoverage
 * @returns AvailableImageryResponse Successful Response
 * @throws ApiError
 */
export const postAvailableImagery = (requestBody: PostAvailableImageryData['requestBody'], sourcesToCheck?: PostAvailableImageryData['sourcesToCheck'], fullCoverage?: PostAvailableImageryData['fullCoverage']): CancelablePromise<PostAvailableImageryResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/v1/available_imagery',
    query: {
        sources_to_check: sourcesToCheck,
        full_coverage: fullCoverage
    },
    body: requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Post Ccu Data
 * Soft deleted targe CUU in DB, and insert a new CCU data into database.
 * @param requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const postCcu = (requestBody: PostCcuData['requestBody']): CancelablePromise<PostCcuResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/v1/ccu',
    body: requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Ccu Trace Details
 * Returns data about the specified CCU
 * If the CCU does not exist, it returns a 400 error
 * @param ccuId
 * @returns CcuTraceResponse Successful Response
 * @throws ApiError
 */
export const getCcu = (ccuId: GetCcuData['ccuId']): CancelablePromise<GetCcuResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/ccu/{ccu_id}',
    path: {
        ccu_id: ccuId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Ccu Forecast Endpoint
 * Get CCU forecast prices.
 * @returns CarbonPrices Successful Response
 * @throws ApiError
 */
export const getCcuForecast = (): CancelablePromise<GetCcuForecastResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/ccu_forecast'
}); };

/**
 * List Companies Endpoint
 * Returns a list of all companies
 * @returns CompanyResponse Successful Response
 * @throws ApiError
 */
export const getCompanies = (): CancelablePromise<GetCompaniesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/companies'
}); };

/**
 * Create Company Endpoint
 * Creates a new company.
 *
 * Note that this requires CompanyProperties to be passed in.
 * @param requestBody
 * @returns CompanyResponse Successful Response
 * @throws ApiError
 */
export const postCompanies = (requestBody: PostCompaniesData['requestBody']): CancelablePromise<PostCompaniesResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/v1/companies',
    body: requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Company Endpoint
 * Get information about a company
 * @param companyId
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const getCompany = (companyId: GetCompanyData['companyId']): CancelablePromise<GetCompanyResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/companies/{company_id}',
    path: {
        company_id: companyId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Company Access
 * Get the features that the user has access to for a given company.
 * @param companyId
 * @returns GetAccessResponse Successful Response
 * @throws ApiError
 */
export const getCompanyAccess = (companyId: GetCompanyAccessData['companyId']): CancelablePromise<GetCompanyAccessResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/companies/{company_id}/access',
    path: {
        company_id: companyId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Create Or Update Custom Species
 * Create or update custom species data for the specified company.
 * @param companyId
 * @param requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const putCompanyCustomSpecies = (companyId: PutCompanyCustomSpeciesData['companyId'], requestBody: PutCompanyCustomSpeciesData['requestBody']): CancelablePromise<PutCompanyCustomSpeciesResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/api/v1/companies/{company_id}/custom_species',
    path: {
        company_id: companyId
    },
    body: requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Company Custom Species
 * Query custom species data for the specified company.
 * @param companyId
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const getCompanyCustomSpecies = (companyId: GetCompanyCustomSpeciesData['companyId']): CancelablePromise<GetCompanyCustomSpeciesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/companies/{company_id}/custom_species',
    path: {
        company_id: companyId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Delete Company Custom Species
 * Delete custom species data for the specified company.
 * @param companyId
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const deleteCompanyCustomSpecies = (companyId: DeleteCompanyCustomSpeciesData['companyId']): CancelablePromise<DeleteCompanyCustomSpeciesResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/api/v1/companies/{company_id}/custom_species',
    path: {
        company_id: companyId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Company Properties Endpoint
 * Get information about a company
 * @param companyId
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const getCompanyProperties = (companyId: GetCompanyPropertiesData['companyId']): CancelablePromise<GetCompanyPropertiesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/companies/{company_id}/properties',
    path: {
        company_id: companyId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Update Company Properties Endpoint
 * Get information about a company
 * @param companyId
 * @param requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const putCompanyProperties = (companyId: PutCompanyPropertiesData['companyId'], requestBody: PutCompanyPropertiesData['requestBody']): CancelablePromise<PutCompanyPropertiesResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/api/v1/companies/{company_id}/properties',
    path: {
        company_id: companyId
    },
    body: requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Upload Participant Specific Tables
 * Get information about a company
 * @param companyId
 * @param formData
 * @returns ParticipantSpecificTable Successful Response
 * @throws ApiError
 */
export const putCompanyPropertiesParticipantSpecificTableXls = (companyId: PutCompanyPropertiesParticipantSpecificTableXlsData['companyId'], formData: PutCompanyPropertiesParticipantSpecificTableXlsData['formData']): CancelablePromise<PutCompanyPropertiesParticipantSpecificTableXlsResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/api/v1/companies/{company_id}/properties/participant_specific_table.xls',
    path: {
        company_id: companyId
    },
    formData,
    mediaType: 'multipart/form-data',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Site Tasks By Company Id
 * Get task list of a company
 * @param companyId
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const getCompanyTasks = (companyId: GetCompanyTasksData['companyId']): CancelablePromise<GetCompanyTasksResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/companies/{company_id}/tasks',
    path: {
        company_id: companyId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Company All Users
 * Get all associated users of  a company
 * @param companyId
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const getCompanyUsers = (companyId: GetCompanyUsersData['companyId']): CancelablePromise<GetCompanyUsersResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/companies/{company_id}/users',
    path: {
        company_id: companyId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Invite User For Company
 * Invite an user to a customer by email and tags.
 * @param companyId
 * @param requestBody
 * @returns CompanyUserResponse Successful Response
 * @throws ApiError
 */
export const postCompanyUsersInvitation = (companyId: PostCompanyUsersInvitationData['companyId'], requestBody: PostCompanyUsersInvitationData['requestBody']): CancelablePromise<PostCompanyUsersInvitationResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/v1/companies/{company_id}/users/invitation',
    path: {
        company_id: companyId
    },
    body: requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Relationship Between Company And User
 * Returns a list of tags that represent the relation between the specified company and user
 * @param companyId
 * @param userId
 * @returns CompanyUserTags Successful Response
 * @throws ApiError
 */
export const getCompanyUser = (companyId: GetCompanyUserData['companyId'], userId: GetCompanyUserData['userId']): CancelablePromise<GetCompanyUserResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/companies/{company_id}/users/{user_id}',
    path: {
        company_id: companyId,
        user_id: userId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Remove Relationship Between Company And User
 * Removes the relationship between the specified company and user
 * @param companyId
 * @param userId
 * @returns void Successful Response
 * @throws ApiError
 */
export const deleteCompanyUserTagsAll = (companyId: DeleteCompanyUserTagsAllData['companyId'], userId: DeleteCompanyUserTagsAllData['userId']): CancelablePromise<DeleteCompanyUserTagsAllResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/api/v1/companies/{company_id}/users/{user_id}/tags/all',
    path: {
        company_id: companyId,
        user_id: userId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Create User Company Association
 * Creates a relationship between a company and a user
 * @param companyId
 * @param userId
 * @param tagname
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const postCompanyUser = (companyId: PostCompanyUserData['companyId'], userId: PostCompanyUserData['userId'], tagname: PostCompanyUserData['tagname']): CancelablePromise<PostCompanyUserResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/v1/companies/{company_id}/users/{user_id}/{tagname}',
    path: {
        company_id: companyId,
        user_id: userId,
        tagname
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Delete User Company Association
 * Removes the relationship between a company and user (eg a person is no longer employed at that company)
 * @param companyId
 * @param userId
 * @param tagname
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const deleteCompanyUser = (companyId: DeleteCompanyUserData['companyId'], userId: DeleteCompanyUserData['userId'], tagname: DeleteCompanyUserData['tagname']): CancelablePromise<DeleteCompanyUserResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/api/v1/companies/{company_id}/users/{user_id}/{tagname}',
    path: {
        company_id: companyId,
        user_id: userId,
        tagname
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Post Ctr Data
 * Soft deleted targe CTR in DB, and insert a new CTR feature data.
 * @param requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const postCtr = (requestBody: PostCtrData['requestBody']): CancelablePromise<PostCtrResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/v1/ctr',
    body: requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Download Ctr Shapefile
 * Download shapefile for all CTR(s).
 *
 * This doesn't do any parsing or validation of the shapefile, the CRS is EPSG:4326.
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const getCtrShapefile = (): CancelablePromise<GetCtrShapefileResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/ctr/shapefile'
}); };

/**
 * Get Ctr Data
 * Query CTR GeoJSON feature data by CTR ID.
 *
 * If the CTR does not exist, it returns a 400 error
 * @param ctrId
 * @returns CtrTraceResponse Successful Response
 * @throws ApiError
 */
export const getCtr = (ctrId: GetCtrData['ctrId']): CancelablePromise<GetCtrResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/ctr/{ctr_id}',
    path: {
        ctr_id: ctrId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get All Customers Ids
 * @returns CustomerId Successful Response
 * @throws ApiError
 */
export const getCustomers = (): CancelablePromise<GetCustomersResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/customers'
}); };

/**
 * Get Location Of All Customers
 * Get location FeatureCollection data of all customers (excluding test sites).
 * @returns FeatureCollection_NoneType_Point_SitePointProperty_NoneType_ Successful Response
 * @throws ApiError
 */
export const getCustomersOverview = (): CancelablePromise<GetCustomersOverviewResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/customers/overview'
}); };

/**
 * Get Customer Access
 * Get the features that the user has access to for a given customer.
 * @param customerId
 * @returns GetAccessResponse Successful Response
 * @throws ApiError
 */
export const getCustomerAccess = (customerId: GetCustomerAccessData['customerId']): CancelablePromise<GetCustomerAccessResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/customers/{customer_id}/access',
    path: {
        customer_id: customerId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Trigger Alt Cert Run
 * Trigger project Alt-Cert evaluation.
 * @param customerId
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const postCustomerAltcertEvaluate = (customerId: PostCustomerAltcertEvaluateData['customerId']): CancelablePromise<PostCustomerAltcertEvaluateResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/v1/customers/{customer_id}/altcert/evaluate',
    path: {
        customer_id: customerId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Balance Carried Forward
 * Get all invoice data for given customer ID.
 * @param customerId
 * @returns BalanceForwardResponse Successful Response
 * @throws ApiError
 */
export const getCustomerBalanceForward = (customerId: GetCustomerBalanceForwardData['customerId']): CancelablePromise<GetCustomerBalanceForwardResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/customers/{customer_id}/balance_forward',
    path: {
        customer_id: customerId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Hubspot Customer Billing Address
 * Return hubspot deal information for a given customer.
 * @param customerId
 * @returns AddressAnswer Successful Response
 * @throws ApiError
 */
export const getCustomerBillingAddress = (customerId: GetCustomerBillingAddressData['customerId']): CancelablePromise<GetCustomerBillingAddressResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/customers/{customer_id}/billing_address',
    path: {
        customer_id: customerId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Customer Boundary
 * Query project boundary of a customer.
 *
 * Args:
 * customer_id: Customer ID
 * dissolve: If true, the service will dissolve parcel borders.
 * @param customerId
 * @param dissolve
 * @param inverted
 * @returns FeatureCollection Successful Response
 * @throws ApiError
 */
export const getCustomerBoundary = (customerId: GetCustomerBoundaryData['customerId'], dissolve: GetCustomerBoundaryData['dissolve'] = false, inverted: GetCustomerBoundaryData['inverted'] = false): CancelablePromise<GetCustomerBoundaryResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/customers/{customer_id}/boundary',
    path: {
        customer_id: customerId
    },
    query: {
        dissolve,
        inverted
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Yields For Project By Caa
 * Get financial forecasts for the area of a project.
 * @param customerId
 * @param segmentsVersionId
 * @returns YieldsForCAA Successful Response
 * @throws ApiError
 */
export const getCustomerCaasYields = (customerId: GetCustomerCaasYieldsData['customerId'], segmentsVersionId?: GetCustomerCaasYieldsData['segmentsVersionId']): CancelablePromise<GetCustomerCaasYieldsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/customers/{customer_id}/caas/yields',
    path: {
        customer_id: customerId
    },
    query: {
        segments_version_id: segmentsVersionId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Evaluate Ets
 * @param customerId
 * @param overwriteSegments
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const postCustomerCarbonStockPipelineEtsEvaluate = (customerId: PostCustomerCarbonStockPipelineEtsEvaluateData['customerId'], overwriteSegments: PostCustomerCarbonStockPipelineEtsEvaluateData['overwriteSegments'] = false): CancelablePromise<PostCustomerCarbonStockPipelineEtsEvaluateResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/v1/customers/{customer_id}/carbon_stock_pipeline/ets/evaluate',
    path: {
        customer_id: customerId
    },
    query: {
        overwrite_segments: overwriteSegments
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Trigger Flow
 * @param customerId
 * @param deploymentId The deployment id of the Prefect flow to trigger.
 * @param flowName The name of the Prefect flow to trigger (e.g. ETS-flow). Will be set as tag.
 * @param requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const postCustomerCarbonStockPipelineRunFlow = (customerId: PostCustomerCarbonStockPipelineRunFlowData['customerId'], deploymentId: PostCustomerCarbonStockPipelineRunFlowData['deploymentId'], flowName: PostCustomerCarbonStockPipelineRunFlowData['flowName'] = 'Flow', requestBody?: PostCustomerCarbonStockPipelineRunFlowData['requestBody']): CancelablePromise<PostCustomerCarbonStockPipelineRunFlowResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/v1/customers/{customer_id}/carbon_stock_pipeline/run_flow',
    path: {
        customer_id: customerId
    },
    query: {
        deployment_id: deploymentId,
        flow_name: flowName
    },
    body: requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get
 * @param customerId
 * @param customerCompanyTag
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const getCustomerCompany = (customerId: GetCustomerCompanyData['customerId'], customerCompanyTag: GetCustomerCompanyData['customerCompanyTag']): CancelablePromise<GetCustomerCompanyResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/customers/{customer_id}/companies/{customer_company_tag}',
    path: {
        customer_id: customerId,
        customer_company_tag: customerCompanyTag
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Post
 * @param customerId
 * @param customerCompanyTag
 * @param requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const postCustomerCompany = (customerId: PostCustomerCompanyData['customerId'], customerCompanyTag: PostCustomerCompanyData['customerCompanyTag'], requestBody: PostCustomerCompanyData['requestBody']): CancelablePromise<PostCustomerCompanyResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/v1/customers/{customer_id}/companies/{customer_company_tag}',
    path: {
        customer_id: customerId,
        customer_company_tag: customerCompanyTag
    },
    body: requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Delete
 * @param customerId
 * @param customerCompanyTag
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const deleteCustomerCompany = (customerId: DeleteCustomerCompanyData['customerId'], customerCompanyTag: DeleteCustomerCompanyData['customerCompanyTag']): CancelablePromise<DeleteCustomerCompanyResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/api/v1/customers/{customer_id}/companies/{customer_company_tag}',
    path: {
        customer_id: customerId,
        customer_company_tag: customerCompanyTag
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Custom Species By Customer Id
 * Return custom species data for the specified customer.
 * @param customerId
 * @param customerCompanyTag
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const getCustomerCompanyCustomSpecies = (customerId: GetCustomerCompanyCustomSpeciesData['customerId'], customerCompanyTag: GetCustomerCompanyCustomSpeciesData['customerCompanyTag']): CancelablePromise<GetCustomerCompanyCustomSpeciesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/customers/{customer_id}/companies/{customer_company_tag}/custom_species',
    path: {
        customer_id: customerId,
        customer_company_tag: customerCompanyTag
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Customer Carbon Manager Custom Species Summary
 * @param customerId
 * @param customerCompanyTag
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const getCustomerCompanyCustomSpeciesSummary = (customerId: GetCustomerCompanyCustomSpeciesSummaryData['customerId'], customerCompanyTag: GetCustomerCompanyCustomSpeciesSummaryData['customerCompanyTag']): CancelablePromise<GetCustomerCompanyCustomSpeciesSummaryResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/customers/{customer_id}/companies/{customer_company_tag}/custom_species/summary',
    path: {
        customer_id: customerId,
        customer_company_tag: customerCompanyTag
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Customer Credit Notes
 * Get all invoice data for given customer ID.
 * @param customerId
 * @returns QueryCreditNoteResponse Successful Response
 * @throws ApiError
 */
export const getCustomerCreditNotes = (customerId: GetCustomerCreditNotesData['customerId']): CancelablePromise<GetCustomerCreditNotesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/customers/{customer_id}/credit_notes',
    path: {
        customer_id: customerId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Economics For Block
 * Get financial forecasts for a block.
 * @param customerId
 * @param requestBody
 * @param startYear
 * @param totalArea
 * @returns BlockEconomics Successful Response
 * @throws ApiError
 */
export const postCustomerEconomicsByFeature = (customerId: PostCustomerEconomicsByFeatureData['customerId'], requestBody: PostCustomerEconomicsByFeatureData['requestBody'], startYear: PostCustomerEconomicsByFeatureData['startYear'] = 2025, totalArea: PostCustomerEconomicsByFeatureData['totalArea'] = 0): CancelablePromise<PostCustomerEconomicsByFeatureResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/v1/customers/{customer_id}/economics/by_feature',
    path: {
        customer_id: customerId
    },
    query: {
        start_year: startYear,
        total_area: totalArea
    },
    body: requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Update Economics
 * Triggers a force refresh of the cached economics data for a customer.
 * @param customerId
 * @returns void Successful Response
 * @throws ApiError
 */
export const postCustomerEconomicsUpdate = (customerId: PostCustomerEconomicsUpdateData['customerId']): CancelablePromise<PostCustomerEconomicsUpdateResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/v1/customers/{customer_id}/economics/update',
    path: {
        customer_id: customerId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Ets Land District
 * Query ETS land districts for the all segments of specific customer.
 * @param customerId
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const getCustomerEtsLandDistrict = (customerId: GetCustomerEtsLandDistrictData['customerId']): CancelablePromise<GetCustomerEtsLandDistrictResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/customers/{customer_id}/ets_land_district',
    path: {
        customer_id: customerId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Customer Root Folder
 * @param customerId
 * @returns string Successful Response
 * @throws ApiError
 */
export const getCustomerGdrive = (customerId: GetCustomerGdriveData['customerId']): CancelablePromise<GetCustomerGdriveResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/customers/{customer_id}/gdrive',
    path: {
        customer_id: customerId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Upload File To Google Drive
 * Returns:
 * List of google drive file source
 * Ref: https://developers.google.com/drive/api/v3/reference/files#resource
 * Ref: https://developers.google.com/drive/api/guides/manage-uploads#python
 * @param internalPath
 * @param customerId
 * @param formData
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const postCustomerGdrive = (internalPath: PostCustomerGdriveData['internalPath'], customerId: PostCustomerGdriveData['customerId'], formData: PostCustomerGdriveData['formData']): CancelablePromise<PostCustomerGdriveResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/v1/customers/{customer_id}/gdrive/{internal_path}',
    path: {
        internal_path: internalPath,
        customer_id: customerId
    },
    formData,
    mediaType: 'multipart/form-data',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Add Service Fee Invoice Data
 * Insert invoice data into Database.
 * @param customerId
 * @param requestBody
 * @returns InvoiceDataResponse Successful Response
 * @throws ApiError
 */
export const postCustomerInvoices = (customerId: PostCustomerInvoicesData['customerId'], requestBody: PostCustomerInvoicesData['requestBody']): CancelablePromise<PostCustomerInvoicesResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/v1/customers/{customer_id}/invoices',
    path: {
        customer_id: customerId
    },
    body: requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Service Fee Invoice Data
 * Get all invoice data for given customer ID.
 * @param customerId
 * @returns InvoiceDataResponse Successful Response
 * @throws ApiError
 */
export const getCustomerInvoices = (customerId: GetCustomerInvoicesData['customerId']): CancelablePromise<GetCustomerInvoicesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/customers/{customer_id}/invoices',
    path: {
        customer_id: customerId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Invoice Pdf
 * Get existing invoice PDF file from Google Drive otherwise capture a new PDF.
 * @param customerId
 * @param invoiceId
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const getCustomerInvoicePdf = (customerId: GetCustomerInvoicePdfData['customerId'], invoiceId: GetCustomerInvoicePdfData['invoiceId']): CancelablePromise<GetCustomerInvoicePdfResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/customers/{customer_id}/invoices/{invoice_id}.pdf',
    path: {
        customer_id: customerId,
        invoice_id: invoiceId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Delete Customer Invoice
 * Delete draft invoice.
 * @param customerId
 * @param invoiceId
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const deleteCustomerInvoice = (customerId: DeleteCustomerInvoiceData['customerId'], invoiceId: DeleteCustomerInvoiceData['invoiceId']): CancelablePromise<DeleteCustomerInvoiceResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/api/v1/customers/{customer_id}/invoices/{invoice_id}',
    path: {
        customer_id: customerId,
        invoice_id: invoiceId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Invoice Pdf In Google Drive
 * Get existing invoice PDF file ID from Google Drive.
 * @param customerId
 * @param invoiceId
 * @returns InvoiceGoogleDriveFileIdResponse Successful Response
 * @throws ApiError
 */
export const getCustomerInvoiceFileId = (customerId: GetCustomerInvoiceFileIdData['customerId'], invoiceId: GetCustomerInvoiceFileIdData['invoiceId']): CancelablePromise<GetCustomerInvoiceFileIdResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/customers/{customer_id}/invoices/{invoice_id}/file_id',
    path: {
        customer_id: customerId,
        invoice_id: invoiceId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Invoice Payments
 * Get all payments for given invoice ID.
 * @param invoiceId
 * @param customerId
 * @returns PaymentResponseData Successful Response
 * @throws ApiError
 */
export const getCustomerInvoicePayments = (invoiceId: GetCustomerInvoicePaymentsData['invoiceId'], customerId: GetCustomerInvoicePaymentsData['customerId']): CancelablePromise<GetCustomerInvoicePaymentsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/customers/{customer_id}/invoices/{invoice_id}/payments',
    path: {
        invoice_id: invoiceId,
        customer_id: customerId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Set Payment Status
 * Update payment status.
 * @param invoiceId
 * @param paymentId
 * @param customerId
 * @param requestBody
 * @returns PaymentResponseData Successful Response
 * @throws ApiError
 */
export const putCustomerInvoicePaymentStatus = (invoiceId: PutCustomerInvoicePaymentStatusData['invoiceId'], paymentId: PutCustomerInvoicePaymentStatusData['paymentId'], customerId: PutCustomerInvoicePaymentStatusData['customerId'], requestBody: PutCustomerInvoicePaymentStatusData['requestBody']): CancelablePromise<PutCustomerInvoicePaymentStatusResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/api/v1/customers/{customer_id}/invoices/{invoice_id}/payments/{payment_id}/status',
    path: {
        invoice_id: invoiceId,
        payment_id: paymentId,
        customer_id: customerId
    },
    body: requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Recalculate Service Fee Invoice
 * Recalculate invoice data.
 * @param invoiceId
 * @param customerId
 * @param requestBody
 * @returns InvoiceDataResponse Successful Response
 * @throws ApiError
 */
export const putCustomerInvoiceProperties = (invoiceId: PutCustomerInvoicePropertiesData['invoiceId'], customerId: PutCustomerInvoicePropertiesData['customerId'], requestBody: PutCustomerInvoicePropertiesData['requestBody']): CancelablePromise<PutCustomerInvoicePropertiesResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/api/v1/customers/{customer_id}/invoices/{invoice_id}/properties',
    path: {
        invoice_id: invoiceId,
        customer_id: customerId
    },
    body: requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * @deprecated
 * Recalculate Service Fee Invoice
 * Recalculate invoice data.
 * @param invoiceId
 * @param customerId
 * @param requestBody
 * @returns InvoiceDataResponse Successful Response
 * @throws ApiError
 */
export const putCustomerInvoicePropertiesNzusIssued = (invoiceId: PutCustomerInvoicePropertiesNzusIssuedData['invoiceId'], customerId: PutCustomerInvoicePropertiesNzusIssuedData['customerId'], requestBody: PutCustomerInvoicePropertiesNzusIssuedData['requestBody']): CancelablePromise<PutCustomerInvoicePropertiesNzusIssuedResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/api/v1/customers/{customer_id}/invoices/{invoice_id}/properties/nzus_issued',
    path: {
        invoice_id: invoiceId,
        customer_id: customerId
    },
    body: requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Send Invoice
 * Send invoice to a given email address
 * @param customerId
 * @param invoiceId
 * @param requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const postCustomerInvoiceSend = (customerId: PostCustomerInvoiceSendData['customerId'], invoiceId: PostCustomerInvoiceSendData['invoiceId'], requestBody: PostCustomerInvoiceSendData['requestBody']): CancelablePromise<PostCustomerInvoiceSendResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/v1/customers/{customer_id}/invoices/{invoice_id}/send',
    path: {
        customer_id: customerId,
        invoice_id: invoiceId
    },
    body: requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Set Service Fee Invoice Status
 * Update invoice status.
 * @param invoiceId
 * @param customerId
 * @param requestBody
 * @returns InvoiceDataResponse Successful Response
 * @throws ApiError
 */
export const putCustomerInvoiceStatus = (invoiceId: PutCustomerInvoiceStatusData['invoiceId'], customerId: PutCustomerInvoiceStatusData['customerId'], requestBody: PutCustomerInvoiceStatusData['requestBody']): CancelablePromise<PutCustomerInvoiceStatusResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/api/v1/customers/{customer_id}/invoices/{invoice_id}/status',
    path: {
        invoice_id: invoiceId,
        customer_id: customerId
    },
    body: requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Generate Customer Kml File
 * Generate Google Earth KML file
 *
 * Args:
 * customer_id: Customer ID
 * @param customerId
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const getCustomerKmlFile = (customerId: GetCustomerKmlFileData['customerId']): CancelablePromise<GetCustomerKmlFileResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/customers/{customer_id}/kml_file',
    path: {
        customer_id: customerId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Create Layer
 * Add new layer to specified project with layer properties and layer GeoJSON feature data.
 *
 * Args:
 * layer_data: LayerPost, layer properties and layer feature data
 * customer_id: Customer ID
 *
 * Returns:
 * example {
 * "layer_id": 37,
 * "version_id": 1530,
 * "properties": {
 * "type": "ai_segmentation",
 * "model_id": "unet_jan-26.s-linz.z16.h5",
 * "version_created": {
 * "user_id": 74,
 * "timestamp": "2022-03-25 15:00"
 * }
 * }
 * }
 * @param customerId
 * @param requestBody
 * @returns LayerModel Successful Response
 * @throws ApiError
 */
export const postCustomerLayers = (customerId: PostCustomerLayersData['customerId'], requestBody: PostCustomerLayersData['requestBody']): CancelablePromise<PostCustomerLayersResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/v1/customers/{customer_id}/layers',
    path: {
        customer_id: customerId
    },
    body: requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get All Project Layers
 * Get all layers data (ID, version and properties) for the specified project.
 *
 * Args:
 * customer_id: Customer ID
 *
 * Returns:
 * LayerListModel, example {
 * "customer_id": 395,
 * "layers": [
 * {
 * "layer_id": 1631761800,
 * "version_id": 1522,
 * "properties": {
 * "type": "ai_segmentation",
 * "model_id": "unet_jan-26.s-linz.z16.h5",
 * "version_created": {
 * "user_id": 74,
 * "timestamp": "2022-03-25 15:00:00"
 * }
 * }
 * },
 * {
 * "layer_id": 1643841238,
 * "version_id": 1527,
 * "properties": {
 * "version_created": {
 * "user_id": 74,
 * "timestamp": "2022-03-25 15:00:00"
 * }
 * }
 * }
 * ]
 * }
 * @param customerId
 * @param ifNoneMatch
 * @returns LayerListModel Successful Response
 * @throws ApiError
 */
export const getCustomerLayers = (customerId: GetCustomerLayersData['customerId'], ifNoneMatch?: GetCustomerLayersData['ifNoneMatch']): CancelablePromise<GetCustomerLayersResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/customers/{customer_id}/layers',
    path: {
        customer_id: customerId
    },
    headers: {
        'if-none-match': ifNoneMatch
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Update Layer
 * Update specified layer with new feature data.
 *
 * Args:
 * layer_id: Layer ID
 * layer_data: Layer properties and layer feature data
 * customer_id: Customer ID
 * Returns:
 * LayerModel, example {
 * "layer_id": 37,
 * "version_id": 1530,
 * "properties": {
 * "type": "ai_segmentation",
 * "model_id": "unet_jan-26.s-linz.z16.h5",
 * "version_created": {
 * "user_id": 74,
 * "timestamp": "2022-03-25 15:00"
 * }
 * }
 * }
 * @param layerId
 * @param customerId
 * @param requestBody
 * @returns LayerModel Successful Response
 * @throws ApiError
 */
export const postCustomerLayer = (layerId: PostCustomerLayerData['layerId'], customerId: PostCustomerLayerData['customerId'], requestBody: PostCustomerLayerData['requestBody']): CancelablePromise<PostCustomerLayerResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/v1/customers/{customer_id}/layers/{layer_id}',
    path: {
        layer_id: layerId,
        customer_id: customerId
    },
    body: requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Layer
 * Query specified layer data for specified project, with specified version ID or latest version.
 *
 * Args:
 * customer_id: Customer ID
 * layer_id: Layer ID of speciefied project
 * version_id: optional query parameter, version ID of specified layer
 *
 * Returns:
 * GeoJSON FeatureCollection, example {
 * "type": "FeatureCollection",
 * "features": [
 * {
 * "type": "Feature",
 * "id": 1234,
 * "properties": {
 * "class": "class_1",
 * "model_id": "unet_jan-26.s-linz.z16.h5"
 * },
 * "geometry": {
 * "type": "Polygon",
 * "coordinates": [
 * [
 * [172.999274, -41.320809],
 * [172.999327, -41.320809],
 * [172.999338, -41.320833],
 * [172.999274, -41.320809]
 * ]
 * ]
 * }
 * }
 * ]
 * }
 * @param layerId
 * @param customerId
 * @param versionId
 * @param ifNoneMatch
 * @returns FeatureCollectionWithId_GeometryTypes_PropertyTypes_NoneType_ Successful Response
 * @throws ApiError
 */
export const getCustomerLayer = (layerId: GetCustomerLayerData['layerId'], customerId: GetCustomerLayerData['customerId'], versionId?: GetCustomerLayerData['versionId'], ifNoneMatch?: GetCustomerLayerData['ifNoneMatch']): CancelablePromise<GetCustomerLayerResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/customers/{customer_id}/layers/{layer_id}',
    path: {
        layer_id: layerId,
        customer_id: customerId
    },
    headers: {
        'if-none-match': ifNoneMatch
    },
    query: {
        version_id: versionId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Delete Layer
 * Delete specified layer for specified project.
 *
 * Args:
 * customer_id: Customer ID
 * @param layerId
 * @param customerId
 * @returns string Successful Response
 * @throws ApiError
 */
export const deleteCustomerLayer = (layerId: DeleteCustomerLayerData['layerId'], customerId: DeleteCustomerLayerData['customerId']): CancelablePromise<DeleteCustomerLayerResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/api/v1/customers/{customer_id}/layers/{layer_id}',
    path: {
        layer_id: layerId,
        customer_id: customerId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get All Versions
 * Get all versions properties of specified layer.
 *
 * Args:
 * layer_id: Layer ID
 * customer_id: Customer ID
 * Returns:
 * VersionListModel, example {
 * "customer_id": 395,
 * "layer_id": 1631761800,
 * "version_list": [
 * {
 * "version": 1552,
 * "properties": {
 * "type": "ai_segmentation",
 * "model_id": unet_jan-26.s-linz.z16.h5",
 * },
 * "is_latest": True,
 * },
 * {
 * "version": 1551,
 * "properties": {
 * "type": "ai_segmentation",
 * "model_id": unet_jan-26.s-linz.z16.h5",
 * },
 * "is_latest": False,
 * }
 * ],
 * }
 * @param layerId
 * @param customerId
 * @returns VersionListModel Successful Response
 * @throws ApiError
 */
export const getCustomerLayerVersions = (layerId: GetCustomerLayerVersionsData['layerId'], customerId: GetCustomerLayerVersionsData['customerId']): CancelablePromise<GetCustomerLayerVersionsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/customers/{customer_id}/layers/{layer_id}/versions',
    path: {
        layer_id: layerId,
        customer_id: customerId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Measures For Project
 * Get measures for the area of a project.
 * @param customerId
 * @param segmentsVersionId
 * @returns DimsAndMeasures Successful Response
 * @throws ApiError
 */
export const getCustomerMeasures = (customerId: GetCustomerMeasuresData['customerId'], segmentsVersionId?: GetCustomerMeasuresData['segmentsVersionId']): CancelablePromise<GetCustomerMeasuresResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/customers/{customer_id}/measures',
    path: {
        customer_id: customerId
    },
    query: {
        segments_version_id: segmentsVersionId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Parcel Status
 * Query title status of target customer.
 *
 * Args:
 * customer_id: Customer ID
 * @param customerId
 * @returns ParcelStatusResponse Successful Response
 * @throws ApiError
 */
export const getCustomerParcelstatus = (customerId: GetCustomerParcelstatusData['customerId']): CancelablePromise<GetCustomerParcelstatusResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/customers/{customer_id}/parcelstatus',
    path: {
        customer_id: customerId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Send Per Email
 * Send PER email to invite landholder for data input.
 * @param customerId
 * @param requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const postCustomerPerEmail = (customerId: PostCustomerPerEmailData['customerId'], requestBody: PostCustomerPerEmailData['requestBody']): CancelablePromise<PostCustomerPerEmailResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/v1/customers/{customer_id}/per_email',
    path: {
        customer_id: customerId
    },
    body: requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Project Photo Requested Points
 * Query requested photo points based on customer id.
 *
 * Args:
 * - customer_id
 * Returns:
 * GeoJSON data of points, features list will be empty if there is no data in DB.
 * example:
 * {
 * "type": "FeatureCollection",
 * "features": [
 * {
 * "type": "Feature",
 * "geometry": {
 * "type": "Point",
 * "coordinates": [173.07851701306177, -43.769251264788764]
 * },
 * "properties": {
 * "id": 1,
 * "status": 0
 * }
 * },
 * ]
 * }
 * @param customerId
 * @returns FeatureCollection Successful Response
 * @throws ApiError
 */
export const getCustomerPhotosRequestedPoints = (customerId: GetCustomerPhotosRequestedPointsData['customerId']): CancelablePromise<GetCustomerPhotosRequestedPointsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/customers/{customer_id}/photos/requested_points',
    path: {
        customer_id: customerId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Post Project Photo Requested Points
 * Insert or update requested photo points associated for a project.
 *
 * The points data is GeoJSON FeatureCollection data.
 *
 * Args:
 * project_id: Project ID
 * points: GeoJSON FeatureCollection data of .
 * @param customerId
 * @param requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const postCustomerPhotosRequestedPoints = (customerId: PostCustomerPhotosRequestedPointsData['customerId'], requestBody: PostCustomerPhotosRequestedPointsData['requestBody']): CancelablePromise<PostCustomerPhotosRequestedPointsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/v1/customers/{customer_id}/photos/requested_points',
    path: {
        customer_id: customerId
    },
    body: requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Upload Photo File
 * Upload photos to project evidence folder.
 *
 * Args:
 * customer_id: Project ID
 * img_files: UploadFile object list
 * Returns:
 * File name and file id in JSON format, example:
 * {
 * "customer_id": 395,
 * "files": [
 * {
 * "file_name": "map-marker-v1.jpeg",
 * "file_id": "18VGGElYOHKfiJQXCxr9O7dRWTjXau"
 * },
 * {
 * "file_name": "marker-editor.jpeg",
 * "file_id": "15uV2KzGaOxjHcJEffTTO1ZBT9nMXP"
 * }
 * ]
 * }
 * @param customerId
 * @param formData
 * @returns api_eoi_server__models__requests__geojson__FeatureCollection_IdTypes_Union_Point__NoneType__PhotoTakenProperties_NoneType___1 Successful Response
 * @throws ApiError
 */
export const postCustomerPhotosTaken = (customerId: PostCustomerPhotosTakenData['customerId'], formData: PostCustomerPhotosTakenData['formData']): CancelablePromise<PostCustomerPhotosTakenResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/v1/customers/{customer_id}/photos/taken',
    path: {
        customer_id: customerId
    },
    formData,
    mediaType: 'multipart/form-data',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Photos Thumbnail
 * Get project evidence photos taken points.
 *
 * Args:
 * customer_id: Project ID
 * file_id: File ID on Google Drive
 * size: Optional, 'thumbnail' when query thumbnail
 * Returns:
 * thumbnail link created by Google Drive, if have
 * empty if no thumbnail is not available
 * 400 exception if file do not exist
 * @param fileId
 * @param customerId
 * @param size
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const getCustomerPhotosTaken = (fileId: GetCustomerPhotosTakenData['fileId'], customerId: GetCustomerPhotosTakenData['customerId'], size?: GetCustomerPhotosTakenData['size']): CancelablePromise<GetCustomerPhotosTakenResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/customers/{customer_id}/photos/taken/{file_id}',
    path: {
        file_id: fileId,
        customer_id: customerId
    },
    query: {
        size
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Delete Photo
 * Delete project evidence photo.
 *
 * Args:
 * customer_id: Project ID
 * file_id: File ID on Google Drive
 * Returns:
 * 200 successfully deleted
 * 400 exception if file do not exist or already deleted
 * @param fileId
 * @param customerId
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const deleteCustomerPhotosTaken = (fileId: DeleteCustomerPhotosTakenData['fileId'], customerId: DeleteCustomerPhotosTakenData['customerId']): CancelablePromise<DeleteCustomerPhotosTakenResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/api/v1/customers/{customer_id}/photos/taken/{file_id}',
    path: {
        file_id: fileId,
        customer_id: customerId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Put Photo Archived
 * @param fileId
 * @param customerId
 * @param requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const putCustomerPhotosTakenArchived = (fileId: PutCustomerPhotosTakenArchivedData['fileId'], customerId: PutCustomerPhotosTakenArchivedData['customerId'], requestBody: PutCustomerPhotosTakenArchivedData['requestBody']): CancelablePromise<PutCustomerPhotosTakenArchivedResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/api/v1/customers/{customer_id}/photos/taken/{file_id}/archived',
    path: {
        file_id: fileId,
        customer_id: customerId
    },
    body: requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Photos Taken Points
 * Get project evidence photos taken points.
 * @param customerId
 * @returns api_eoi_server__models__requests__geojson__FeatureCollection_IdTypes_Union_Point__NoneType__PhotoTakenProperties_NoneType___2 Successful Response
 * @throws ApiError
 */
export const getCustomerPhotosTakenPoints = (customerId: GetCustomerPhotosTakenPointsData['customerId']): CancelablePromise<GetCustomerPhotosTakenPointsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/customers/{customer_id}/photos/taken_points',
    path: {
        customer_id: customerId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Customer Properties By Id
 * Query customer properties based on customer id.
 *
 * These properties are things like comments, report values, etc.
 *
 * Args:
 * - session: Database session
 * - customer_id: Customer ID
 * - user_data: UserData
 * @param customerId
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const getCustomerProperties = (customerId: GetCustomerPropertiesData['customerId']): CancelablePromise<GetCustomerPropertiesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/customers/{customer_id}/properties',
    path: {
        customer_id: customerId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Post Customer Properties
 * Insert or update the properties associated with a customer.
 *
 * These properties are things like comments, report values, etc.
 *
 * Args:
 * - customer_id
 * @param customerId
 * @param requestBody
 * @returns CustomerProperties Successful Response
 * @throws ApiError
 */
export const postCustomerProperties = (customerId: PostCustomerPropertiesData['customerId'], requestBody: PostCustomerPropertiesData['requestBody']): CancelablePromise<PostCustomerPropertiesResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/v1/customers/{customer_id}/properties',
    path: {
        customer_id: customerId
    },
    body: requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Segment Properties
 * Returns the properties of a single feature in the project
 * @param featureId
 * @param topLevelProperty
 * @param customerId
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const getCustomerSegmentationFeatureProperty = (featureId: GetCustomerSegmentationFeaturePropertyData['featureId'], topLevelProperty: GetCustomerSegmentationFeaturePropertyData['topLevelProperty'], customerId: GetCustomerSegmentationFeaturePropertyData['customerId']): CancelablePromise<GetCustomerSegmentationFeaturePropertyResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/customers/{customer_id}/segmentation/features/{feature_id}/properties/{top_level_property}',
    path: {
        feature_id: featureId,
        top_level_property: topLevelProperty,
        customer_id: customerId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Patch Segment Properties
 * Updates the properties of a feature to match new values. This is useful for
 * doing a partial update of a project.
 * Returns the featureID of the feature that replaces this one or raises a 400 error
 * if the feature does not exist.
 * @param customerId
 * @param featureId
 * @param topLevelProperty
 * @param requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const patchCustomerSegmentationFeatureProperty = (customerId: PatchCustomerSegmentationFeaturePropertyData['customerId'], featureId: PatchCustomerSegmentationFeaturePropertyData['featureId'], topLevelProperty: PatchCustomerSegmentationFeaturePropertyData['topLevelProperty'], requestBody: PatchCustomerSegmentationFeaturePropertyData['requestBody']): CancelablePromise<PatchCustomerSegmentationFeaturePropertyResponse> => { return __request(OpenAPI, {
    method: 'PATCH',
    url: '/api/v1/customers/{customer_id}/segmentation/features/{feature_id}/properties/{top_level_property}',
    path: {
        customer_id: customerId,
        feature_id: featureId,
        top_level_property: topLevelProperty
    },
    body: requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Insert Customer Segmentation
 * Insert segmentation (feature) data into database with new URL.
 * @param customerId
 * @param requestBody
 * @returns SegmentationPostResponse Successful Response
 * @throws ApiError
 */
export const postCustomerSegments = (customerId: PostCustomerSegmentsData['customerId'], requestBody: PostCustomerSegmentsData['requestBody']): CancelablePromise<PostCustomerSegmentsResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/v1/customers/{customer_id}/segments',
    path: {
        customer_id: customerId
    },
    body: requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Customer Segmentation
 * Query customer segments.
 * @param customerId
 * @param versionId
 * @param ifNoneMatch
 * @returns FeatureCollection_IdTypes_GeometryTypes_CommonGeoJsonProperties_SegmentationMetadata_ Successful Response
 * @throws ApiError
 */
export const getCustomerSegments = (customerId: GetCustomerSegmentsData['customerId'], versionId?: GetCustomerSegmentsData['versionId'], ifNoneMatch?: GetCustomerSegmentsData['ifNoneMatch']): CancelablePromise<GetCustomerSegmentsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/customers/{customer_id}/segments',
    path: {
        customer_id: customerId
    },
    headers: {
        'if-none-match': ifNoneMatch
    },
    query: {
        version_id: versionId
    },
    errors: {
        304: 'Not Modified',
        422: 'Validation Error'
    }
}); };

/**
 * Upload Ets Registered Segments
 * Update ETS registered polygons to segments layer.
 * @param customerId
 * @param requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const postCustomerSegmentsEtsRegistration = (customerId: PostCustomerSegmentsEtsRegistrationData['customerId'], requestBody: PostCustomerSegmentsEtsRegistrationData['requestBody']): CancelablePromise<PostCustomerSegmentsEtsRegistrationResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/v1/customers/{customer_id}/segments/ets/registration',
    path: {
        customer_id: customerId
    },
    body: requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Ets Registered Segments
 * @param customerId
 * @param versionId
 * @returns FeatureCollection_IdTypes_GeometryTypes_PropertyTypes_SegmentationMetadata_ Successful Response
 * @throws ApiError
 */
export const getCustomerSegmentsEtsRegistration = (customerId: GetCustomerSegmentsEtsRegistrationData['customerId'], versionId?: GetCustomerSegmentsEtsRegistrationData['versionId']): CancelablePromise<GetCustomerSegmentsEtsRegistrationResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/customers/{customer_id}/segments/ets/registration',
    path: {
        customer_id: customerId
    },
    query: {
        version_id: versionId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Tasks By Site Id
 * Get all task for a site.
 * @param customerId
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const getCustomerTasks = (customerId: GetCustomerTasksData['customerId']): CancelablePromise<GetCustomerTasksResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/customers/{customer_id}/tasks',
    path: {
        customer_id: customerId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Update Task Endpoint
 * Update or create a task
 * @param customerId
 * @param requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const putCustomerTasks = (customerId: PutCustomerTasksData['customerId'], requestBody: PutCustomerTasksData['requestBody']): CancelablePromise<PutCustomerTasksResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/api/v1/customers/{customer_id}/tasks',
    path: {
        customer_id: customerId
    },
    body: requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * @deprecated
 * Create Invoice Task
 * Create invoice task and associate with a blank invoice.
 * @param customerId
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const postCustomerTasksInvoice = (customerId: PostCustomerTasksInvoiceData['customerId']): CancelablePromise<PostCustomerTasksInvoiceResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/v1/customers/{customer_id}/tasks/invoice',
    path: {
        customer_id: customerId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Delete Task Endpoint
 * Soft-deletes a task
 * @param customerId
 * @param taskUuid
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const deleteCustomerTask = (customerId: DeleteCustomerTaskData['customerId'], taskUuid: DeleteCustomerTaskData['taskUuid']): CancelablePromise<DeleteCustomerTaskResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/api/v1/customers/{customer_id}/tasks/{task_uuid}',
    path: {
        customer_id: customerId,
        task_uuid: taskUuid
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Post Site Titles
 * @param customerId
 * @param requestBody
 * @param runAi
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const postCustomerTitles = (customerId: PostCustomerTitlesData['customerId'], requestBody: PostCustomerTitlesData['requestBody'], runAi: PostCustomerTitlesData['runAi'] = false): CancelablePromise<PostCustomerTitlesResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/v1/customers/{customer_id}/titles',
    path: {
        customer_id: customerId
    },
    query: {
        run_ai: runAi
    },
    body: requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Site Titles
 * @param customerId
 * @returns TitlesResponse Successful Response
 * @throws ApiError
 */
export const getCustomerTitles = (customerId: GetCustomerTitlesData['customerId']): CancelablePromise<GetCustomerTitlesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/customers/{customer_id}/titles',
    path: {
        customer_id: customerId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Token For Site
 * @param customerId
 * @returns string Successful Response
 * @throws ApiError
 */
export const getCustomerToken = (customerId: GetCustomerTokenData['customerId']): CancelablePromise<GetCustomerTokenResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/customers/{customer_id}/token',
    path: {
        customer_id: customerId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Users For Customer
 * @param customerId
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const getCustomerUsers = (customerId: GetCustomerUsersData['customerId']): CancelablePromise<GetCustomerUsersResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/customers/{customer_id}/users',
    path: {
        customer_id: customerId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Invite User For Customer
 * Invite an user to a customer by email and tags.
 * @param customerId
 * @param requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const postCustomerUsersInvitation = (customerId: PostCustomerUsersInvitationData['customerId'], requestBody: PostCustomerUsersInvitationData['requestBody']): CancelablePromise<PostCustomerUsersInvitationResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/v1/customers/{customer_id}/users/invitation',
    path: {
        customer_id: customerId
    },
    body: requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Remove User Site Access
 * Remove user access from a site.
 * @param customerId
 * @param userId
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const deleteCustomerUser = (customerId: DeleteCustomerUserData['customerId'], userId: DeleteCustomerUserData['userId']): CancelablePromise<DeleteCustomerUserResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/api/v1/customers/{customer_id}/users/{user_id}',
    path: {
        customer_id: customerId,
        user_id: userId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Post User For Customer
 * @param customerId
 * @param userId
 * @param tagname
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const postCustomerUserTag = (customerId: PostCustomerUserTagData['customerId'], userId: PostCustomerUserTagData['userId'], tagname: PostCustomerUserTagData['tagname']): CancelablePromise<PostCustomerUserTagResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/v1/customers/{customer_id}/users/{user_id}/tags/{tagname}',
    path: {
        customer_id: customerId,
        user_id: userId,
        tagname
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Delete User For Customer
 * @param customerId
 * @param userId
 * @param tagname
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const deleteCustomerUserTag = (customerId: DeleteCustomerUserTagData['customerId'], userId: DeleteCustomerUserTagData['userId'], tagname: DeleteCustomerUserTagData['tagname']): CancelablePromise<DeleteCustomerUserTagResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/api/v1/customers/{customer_id}/users/{user_id}/tags/{tagname}',
    path: {
        customer_id: customerId,
        user_id: userId,
        tagname
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Hubspot Deals
 * Return hubspot deal information for a given customer.
 * @param customerId
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const getHubspotDeal = (customerId: GetHubspotDealData['customerId']): CancelablePromise<GetHubspotDealResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/hubspot/deals/{customer_id}',
    path: {
        customer_id: customerId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Update Project Properties In Hubspot
 * Update properties in hubspot for a given deal.
 * @param customerId
 * @param requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const postHubspotDealProperties = (customerId: PostHubspotDealPropertiesData['customerId'], requestBody: PostHubspotDealPropertiesData['requestBody']): CancelablePromise<PostHubspotDealPropertiesResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/v1/hubspot/deals/{customer_id}/properties',
    path: {
        customer_id: customerId
    },
    body: requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Ccu Forecast Endpoint
 * Get CCU forecast prices.
 * @returns CarbonPrices Successful Response
 * @throws ApiError
 */
export const getNzuForecast = (): CancelablePromise<GetNzuForecastResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/nzu_forecast'
}); };

/**
 * @deprecated
 * Remove User Site Access Deprecated
 * Remove user access from a site.
 * @param siteId
 * @param userId
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const deleteSiteUser = (siteId: DeleteSiteUserData['siteId'], userId: DeleteSiteUserData['userId']): CancelablePromise<DeleteSiteUserResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/api/v1/sites/{site_id}/users/{user_id}',
    path: {
        site_id: siteId,
        user_id: userId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Create User By Email
 * @param requestBody
 * @returns CreateUserResponse Successful Response
 * @throws ApiError
 */
export const postUsers = (requestBody: PostUsersData['requestBody']): CancelablePromise<PostUsersResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/v1/users',
    body: requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Query User
 * @param email
 * @returns UserInfoResponse Successful Response
 * @throws ApiError
 */
export const getUsers = (email: GetUsersData['email']): CancelablePromise<GetUsersResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/users',
    query: {
        email
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Current User
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const getUsersMe = (): CancelablePromise<GetUsersMeResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/users/me'
}); };

/**
 * Get Current User Companies
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const getUsersMeCompanies = (): CancelablePromise<GetUsersMeCompaniesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/users/me/companies'
}); };

/**
 * Get Current User Customers
 * @returns CustomersForUser Successful Response
 * @throws ApiError
 */
export const getUsersMeCustomers = (): CancelablePromise<GetUsersMeCustomersResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/users/me/customers'
}); };

/**
 * Get Current User Token
 * @returns TokenResponse Successful Response
 * @throws ApiError
 */
export const getUsersMeToken = (): CancelablePromise<GetUsersMeTokenResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/users/me/token'
}); };

/**
 * Get User By Id
 * @param userId
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const getUser = (userId: GetUserData['userId']): CancelablePromise<GetUserResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/users/{user_id}',
    path: {
        user_id: userId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Update User By Id
 * @param userId
 * @param requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const putUser = (userId: PutUserData['userId'], requestBody: PutUserData['requestBody']): CancelablePromise<PutUserResponse> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/api/v1/users/{user_id}',
    path: {
        user_id: userId
    },
    body: requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Delete User By Id
 * @param userId
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const deleteUser = (userId: DeleteUserData['userId']): CancelablePromise<DeleteUserResponse> => { return __request(OpenAPI, {
    method: 'DELETE',
    url: '/api/v1/users/{user_id}',
    path: {
        user_id: userId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get User Companies
 * Query user companies and tags for company management.
 * @param userId
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const getUserCompanies = (userId: GetUserCompaniesData['userId']): CancelablePromise<GetUserCompaniesResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/users/{user_id}/companies',
    path: {
        user_id: userId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get User Customers
 * @param userId
 * @returns CustomersForUser Successful Response
 * @throws ApiError
 */
export const getUserCustomers = (userId: GetUserCustomersData['userId']): CancelablePromise<GetUserCustomersResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v1/users/{user_id}/customers',
    path: {
        user_id: userId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Customers Managed By Company V2
 * Return all properties (customers) list of the specified company. Currently just dummy data
 * @param companyId
 * @returns SitesListResponse Successful Response
 * @throws ApiError
 */
export const getCompanyCustomersV2 = (companyId: GetCompanyCustomersV2Data['companyId']): CancelablePromise<GetCompanyCustomersV2Response> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v2/companies/{company_id}/customers',
    path: {
        company_id: companyId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Create User Customer
 * @param requestBody
 * @returns CreateCustomerResponse Successful Response
 * @throws ApiError
 */
export const postCustomersV2 = (requestBody: PostCustomersV2Data['requestBody']): CancelablePromise<PostCustomersV2Response> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/v2/customers',
    body: requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Get Economics For Project
 * Get financial forecasts for the area of a project.
 * @param customerId
 * @param segmentsVersionId
 * @param status
 * @returns GetFinancePlanResponse Successful Response
 * @throws ApiError
 */
export const getCustomerEconomicsV2 = (customerId: GetCustomerEconomicsV2Data['customerId'], segmentsVersionId?: GetCustomerEconomicsV2Data['segmentsVersionId'], status?: GetCustomerEconomicsV2Data['status']): CancelablePromise<GetCustomerEconomicsV2Response> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/v2/customers/{customer_id}/economics',
    path: {
        customer_id: customerId
    },
    query: {
        segments_version_id: segmentsVersionId,
        status
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * @deprecated
 * Post Update Customer Economics
 * Update this customer's economics
 * @param customerId
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const postCustomerEconomicsV2 = (customerId: PostCustomerEconomicsV2Data['customerId']): CancelablePromise<PostCustomerEconomicsV2Response> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/v2/customers/{customer_id}/economics',
    path: {
        customer_id: customerId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Converter Shapefile
 * Converts from geojson into a shapefile. This doesn't do
 * any parsing or validation of the shapefile other than convert it to
 * EPSG:2193
 *
 * ProjectID is only used for internal bookkeeping/filenaming/access control
 * @param customerId
 * @param requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const postCustomerShapefileV2 = (customerId: PostCustomerShapefileV2Data['customerId'], requestBody: PostCustomerShapefileV2Data['requestBody']): CancelablePromise<PostCustomerShapefileV2Response> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/api/v2/customers/{customer_id}/shapefile',
    path: {
        customer_id: customerId
    },
    body: requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Create Invoice Task
 * Create invoice task and associate with a blank invoice.
 * @param customerId
 * @param parentTaskId The parent task to associate this invoice with
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const putCustomerTasksInvoiceV2 = (customerId: PutCustomerTasksInvoiceV2Data['customerId'], parentTaskId: PutCustomerTasksInvoiceV2Data['parentTaskId']): CancelablePromise<PutCustomerTasksInvoiceV2Response> => { return __request(OpenAPI, {
    method: 'PUT',
    url: '/api/v2/customers/{customer_id}/tasks/invoice',
    path: {
        customer_id: customerId
    },
    query: {
        parent_task_id: parentTaskId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Version
 * Returns information about what version of the AI service this is
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const getVersion = (): CancelablePromise<GetVersionResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/api/version'
}); };

/**
 * Api Info
 * Service infomation for root URL.
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const get = (): CancelablePromise<GetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/'
}); };

/**
 * Redirect To Docs
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const getDocs = (): CancelablePromise<GetDocsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/docs'
}); };